<h2 mat-dialog-title>Repeat pattern</h2>

<mat-dialog-content class="recurrence-dialog-content">
  <!-- Repeat Every -->
  <div class="row align-center">
    <span class="label-text">Repeat every</span>
    <mat-form-field appearance="outline" class="number-field">
      <input matInput type="number" min="1" [(ngModel)]="interval">
    </mat-form-field>
    <mat-form-field appearance="outline" class="medium-field">
      <mat-select [(ngModel)]="frequency" (selectionChange)="onFrequencyChange()">
        <mat-option value="DAILY">day(s)</mat-option>
        <mat-option value="WEEKLY">week(s)</mat-option>
        <mat-option value="MONTHLY">month(s)</mat-option>
        <mat-option value="YEARLY">year(s)</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Days of the week (Reserveert altijd ruimte) -->
  <div class="days-picker-container" [class.invisible]="frequency !== 'WEEKLY'">
    <label class="label-text">Repeat on</label>
    <div class="day-buttons">
      <button type="button" 
              *ngFor="let day of weekDays" 
              class="day-btn" 
              [class.selected]="selectedDays.includes(day.value)"
              (click)="toggleDay(day.value)">
        {{ day.label }}
      </button>
    </div>
  </div>

  <!-- End Recurrence -->
  <div class="end-section">
    <label class="label-text">Ends</label>
    <mat-radio-group [(ngModel)]="endType" class="end-radio-group">
      
      <div class="radio-row">
        <mat-radio-button value="NEVER">Never</mat-radio-button>
      </div>

      <div class="radio-row">
        <mat-radio-button value="UNTIL">
          <span class="no-wrap">On date</span>
        </mat-radio-button>
        <div class="slot-container">
          <mat-form-field appearance="outline" class="date-field" *ngIf="endType === 'UNTIL'">
            <input matInput [matDatepicker]="untilPicker" [(ngModel)]="untilDate">
            <mat-datepicker-toggle matSuffix [for]="untilPicker"></mat-datepicker-toggle>
            <mat-datepicker #untilPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="radio-row">
        <mat-radio-button value="COUNT">
          <span class="no-wrap">After</span>
        </mat-radio-button>
        <div class="slot-container flex-row">
          <ng-container *ngIf="endType === 'COUNT'">
            <mat-form-field appearance="outline" class="number-field">
              <input matInput type="number" min="1" [(ngModel)]="count">
            </mat-form-field>
            <span class="no-wrap">occurrences</span>
          </ng-container>
        </div>
      </div>

    </mat-radio-group>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</mat-dialog-actions>